import React from "react";
import Header from "../Components/Header";
import HeroSection from "./Hero";
 import Solutions from "./YourXcrow"
 import DigitalAssets from "./XcrowStep";
 import DigitalAssets2 from "./DigitalAssets";
 import Commitment from "./SixSection";
import Footer from "../Components/Footer";
import CTASection from "../AboutUs/CtaSection";

function TennetHome() {
  return (
    <div>
      <main>
      <Header />
        <HeroSection />
         <Solutions />
        <Commitment />
         <DigitalAssets />
         <DigitalAssets2 />

        {/* <DeploymentSection /> */}
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}

export default TennetHome;
